import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, TemplateRef, ViewChild, ViewEncapsulation, forwardRef, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from '@angular/core';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AiService } from '../../services/ai.service';
import * as cheerio from 'cheerio';
import { quillConfig } from './quill.config';
import { CustomNgbModalService } from '../../services/custom-ngbmodal.service';
import RichEditorUtil from './utils';
import { debounceTime, map, Subscription, tap } from 'rxjs';


export enum AIGeneratorTypeEnum {
  none = 'none',
  short_description = 'short_description',
  long_description = 'long_description',
  question = 'question'
}
@Component({
  selector: 'app-rich-editor',
  templateUrl: './rich-editor.component.html',
  styleUrls: ['./rich-editor.component.css'],
  
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RichEditorComponent),
      multi: true
    }
  ]
})
export class RichEditorComponent implements OnInit, AfterViewInit, OnDestroy {
  htmlDebugContent: string = "";
  aIGeneratorTypeEnum = AIGeneratorTypeEnum;
  aiStatus: 'none' | 'loading' | 'done'= 'none'
  @Input() content: string = '';
  @Output() contentChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() containerClass: string;
  @Input() editorClass: string;
  @Input() editorID: string;
  @Input() inputPlaceholder: string = 'Your story begins here...';
  @ViewChild('modalContainer') modalContent: TemplateRef<any>;
  @Input() modalRef: NgbModalRef;

  hideBuiltInAiButton: boolean = false;

  @Input() promptFunction: (inputValue:string, auxiliaryValue?: string)=> string = (inputValue: string): string => {
    return `Generate a fully html formatted, long description for webpage with emojis including overview and objectives and methodology and prerequisites and thoughts for a course about '${inputValue}':`
  }

  modalMode: boolean = false;

  @Input() generatorInputValue: string;

  @Input() inputFormControl: FormControl<any> | any;

  quillConfig = quillConfig

  editorController: RichEditorUtil;
  // Implement ControlValueAccessor methods
  
  
  @Output() CatchController = new EventEmitter<RichEditorUtil>();
  subscriptions: Subscription[] = [];
  constructor( private modalService: CustomNgbModalService, private ai: AiService) {
    if (!this.editorID?.length) {
      this.editorID = RichEditorUtil.generateUniqueID();
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    
      this.initializeEditor();
      setTimeout(() => {
        this.initFullScreenButton();
    }, 500);
    
    
    
  }


  initializeEditor() {

    this.editorController = new RichEditorUtil(
      {
        // content: this.initialContent,
        editorID: this.editorID,
        placeholder: this.inputPlaceholder,
        promptFunction: this.promptFunction,
      },
      this.ai
    );

    this.subscriptions.push(
      this.editorController.onReady$.subscribe(this._onReady)
    );
    this.subscriptions.push(
      this.editorController.onChange$.pipe(
        tap(() => this._onDebounceStart()), // Action when debounce starts
        debounceTime(3500),
        tap(() => this._onDebounceEnd()),   // Action when debounce ends
        map((value) => this._onChange(value))   // Your main change logic
      ).subscribe()
    );
  }

  private _onDebounceStart() {
    console.log('Debounce started');
    this.editorController.debonucing = true;
    // Add your start logic here
  }

  private _onDebounceEnd() {
    console.log('Debounce ended');
    this.editorController.debonucing = false;
    // Add your end logic here
  }


  private _onChange: (value: string) => void = (value: string) => {
    console.log('change', value);
    this.contentChange.emit(value);
  };

  private _onReady = () => {
    this.CatchController.emit(this.editorController);
  };


  writeValue(content: string): void {
    this.content = content;
  }

  

  onInputChange(event: any) {


    this._onChange(this.content); // Notify parent component about the content change
  }

  decodeHTMLEntities(text) {
    const element = document.createElement("div");
    element.innerHTML = text;
    return element.textContent;
  }
  appendToContent(value: string) {
    let TempContent = this.decodeHTMLEntities(this.content)
    TempContent += value;
    this.content = TempContent;
    
    this._onChange(this.content); // Notify parent component about the content change
  }






  initFullScreenButton() {
       // Get the custom button element and the Quill editor container
       const customButton = document.getElementById(`${this.editorID}_custom-button`);
       const quillEditor = document.getElementById(this.editorID);
       const quillEditorContainer = quillEditor.querySelector('.ql-toolbar');



       if (quillEditorContainer) {
         // Add the custom button element to the Quill toolbar
         quillEditorContainer.appendChild(customButton).classList.remove('d-none');
       }

      //  // Add event listener to the custom button
      //  customButton.addEventListener('click', () => {
      //    
      //    // Implement your custom button's functionality here
      //  });
  }

    // Add custom button functionality here
    onCustomButtonClick() {
      
      this.open();
      // Implement your custom button's functionality here
    }




    closeModal() {
      this.modalRef.dismiss();
    }
    // Affiliate Links List

    // Modal Open
    async open(content?) {
      this.onOpenModal();
      this.modalRef = this.modalService.open(this.modalContent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        fullscreen: true,
        backdrop: true,
        animation: false,
        // modal-animate-in
        windowClass: 'global-modal-class modal-animate-in full-screen-modal',
        beforeDismiss: ()=> {
          this.modalMode = false;
          return true;
        }
      });

    }

    async onOpenModal() {
      this.modalMode = true;
      // this.loaded = false;
      // await this.getCurrentAnnouncement();
      // this.loaded = true;
    }

    // decodeHTMLEntities(text) {
    //   const element = document.createElement("div");
    //   element.innerHTML = text;
    //   return element.innerHTML;
    // }

    async startGenerating(
      courseTitle: string = this.generatorInputValue
    ) {
      this.editorController.startGenerating(this.promptFunction);
    }

}
